export const validatePartnerInputs = (form, errors, setErrors) => {
    const errorList = { ...errors };

    const fields = ['name', 'email', 'company', 'subject', 'message'];

    for (const field of fields) {
        if (field in form) errorList[field] = !form[field].length;
    }

    setErrors({
        ...errorList
    });

    const validated = Object.values(errorList).every((error) => !error);

    if (validated) return validated;
};
